export const CONFIG = {
  publisherId: 'ca-pub-6062692039613877',
  slot: {
    bannerRight: '2711640587',
    bannerLeft: '6308659729',
    bannerBottom: '6490006017',
  },
};
